angular.module('natgeo').controller('Level4SplashScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'SoundEngine', 'Analytics',
function Level4SplashScreen($scope, element, ScreenFactory, manager, container, SoundEngine, Analytics)
{
	var screen = ScreenFactory( 'level4_splash', element );
	
	screen.once('introBefore', function()
	{
		anim8.save('level4SplashCircle', {
			keyframe: {
				'0': {
					translate: 0,
					opacity: 1
				},
				'25': {
					translate: {x:-5, y:-5},
					opacity: 0.8
				},
				'50': {
					translate: {x:0, y:-10},
					opacity: 0.9
				},
				'75': {
					translate: {x:5, y:-5},
					opacity: 0.85
				},
				'100': {
					translate: 0,
					opacity: 1.0
				}
			},
			units: {
				translate: '%'
			}
		}, {
			easing: 'linear'
		});

		anim8.save('level4SplashSub', {
			keyframe: {
				from: {
					translate: 0
				},
				to: {
					translate: {
						x: 255,
						y: -255
					}
				}
			},
			units: {
				translate: '%'
			}
		}, {
			easing: 'linear'
		});
	});

	// How long to wait after intro before progressing to the next screen (in milliseconds).
	var WAIT_TIME = 13.5 * 1000;

	// Wait X seconds after intro has finished before progressing to the next screen
	screen.on('introEnd', function()
	{
		setTimeout(function()
		{
			$scope.begin(); 

		}, WAIT_TIME);

		Analytics.start('Ocean Cleanup');
	});

	screen.on('introBefore', function()
	{
		SoundEngine.play('ocean-splash', {loop:-1});

		var invisible = {
			opacity: 0
		};

		screen._overlay.setAttributes( invisible );
		screen._trash1.setAttributes( invisible );
		screen._trash2.setAttributes( invisible );
		screen._trash3.setAttributes( invisible );
	});

	screen.on('introEnd', function()
	{
		screen._overlay.play('fadeIn 4s');
		screen._trash1.play('fadeIn 6s');
		screen._trash2.play('fadeIn 8s');
		screen._trash3.play('fadeIn 10s');
	});
	
	// The next screen is the define screen
	$scope.begin = function()
	{
		SoundEngine.stopAll();

		manager.transition('level4_define');
	};
	
}]);